/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Enable_HelpInputs */



/**
* | output |
* | --- |
* | "Enable or disable foot pedal control." |
*
* @param {Options_Pedal_Enable_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_enable_help = /** @type {((inputs?: Options_Pedal_Enable_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Enable_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer ou désactiver le contrôle par pédale.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fußpedalsteuerung aktivieren oder deaktivieren.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita o disabilita il controllo tramite pedale.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включение или отключение управления с помощью ножной педали.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar o deshabilitar el control del pedal.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用或禁用脚踏板控制。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フットペダルコントロールを有効または無効にします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फुट पेडल कंट्रोल को चालू या बंद करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar ou desativar o controle por pedal.")
	return /** @type {LocalizedString} */ ("Enable or disable foot pedal control.")
});